// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"b7a14642","498":"2edeba1e","513":"5dc94774"}[chunkId] + ".chunk.js";
};